// src/libraries/HierarchyManager.js
import layoutEngine from "./layoutEngine";
class HierarchyManager {
    constructor() {
      this.instances = [];
    }
  
    setInstances(instanceList) {
      this.instances = instanceList;
    }

    addCell(cell) {
  this.instances.push(cell);
}

  
    getAll() {
      return this.instances;
    }
  
    buildTree(rootName = 'TOP') {
      const visited = new Set();
  
      const build = (cellName) => {
        if (visited.has(cellName)) return null;
        visited.add(cellName);
  
        const cell = window.layoutEngine?.getCellByName(cellName);
        if (!cell) return null;
  
        return {
          name: cell.name,
          children: (cell.instances || [])
            .map(inst => build(inst.ref))
            .filter(Boolean),
        };
      };
  
      const tree = build(rootName);
      if (tree) {
        window.ProjectManager?.setTopCellName(rootName);  // ← Add this line
      }
      return tree ? [tree] : [];
    }
  
  
    getByName(name) {
      return this.instances.find((inst) => inst.name === name);
    }
  }
  
  const hierarchyManager = new HierarchyManager();
  export default hierarchyManager;

    export function getInstanceCounts() {
    const cells = layoutEngine.getCells();
    const map = {};
  
    for (let cell of cells) {
      for (let inst of cell.instances || []) {
        const key = `${cell.name}→${inst.ref}`;
        map[key] = (map[key] || 0) + 1;
      }
    }
  
    return map;
  }
  